var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dark-layout"},[_c('div',{staticClass:"auth__header"},[_c('router-link',{staticClass:"auth__header-link",attrs:{"active-class":"active","to":"/","exact":""}},[_vm._v(" Вход ")]),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }